import Vue from 'vue'
import App from './App'
import '../../config/rem'
/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {
    app: App
  }
})



// WEBPACK FOOTER //
// ./src/module/index/index.js